import { render, staticRenderFns } from "./DesktopSearchBar.vue?vue&type=template&id=7b9a1ead&scoped=true"
import script from "./DesktopSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopSearchBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DesktopSearchBar.vue?vue&type=style&index=0&id=7b9a1ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9a1ead",
  null
  
)

export default component.exports